/* EMMERI winkelwagen in Lisa-stijl (Claude 21-10-2026): upsell en teller/totaal. Werkt met de Impulse-lade (cart:build / cart:updated). */
(function(){
  function geld(c){ return (window.theme && theme.Currency) ? theme.Currency.formatMoney(c, theme.settings.moneyFormat) : (c/100).toFixed(2); }
  function zet(cart){
    var n = 0, pv = window.clProtectionId;
    (cart.items || []).forEach(function(i){ if (i.variant_id != pv) n += i.quantity; });
    document.querySelectorAll('[data-cl-count]').forEach(function(e){ e.textContent = n; });
    document.querySelectorAll('[data-cl-total]').forEach(function(e){ e.innerHTML = geld(cart.total_price); });
  }
  document.addEventListener('cart:updated', function(e){ if (e.detail && e.detail.cart) zet(e.detail.cart); });
  /* Impulse stuurt niet altijd cart:updated: lees de wagen opnieuw als de productlijst in de lade verandert */
  var wacht; function ververs(){ clearTimeout(wacht); wacht = setTimeout(function(){ fetch('/cart.js').then(function(r){ return r.json(); }).then(zet); }, 150); }
  function kijk(){ var p = document.querySelector('#CartDrawer [data-products]'); if (p && window.MutationObserver) new MutationObserver(ververs).observe(p, { childList: true, subtree: true }); ververs(); }
  document.addEventListener('cart:open', ververs);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kijk); else kijk();
  document.addEventListener('click', function(e){
    var nav = e.target.closest && e.target.closest('[data-up-nav]');
    if (nav) { var r = nav.parentNode.querySelector('.cl-up__row'); r.scrollBy({ left: r.clientWidth * Number(nav.dataset.upNav), behavior: 'smooth' }); return; }
    var b = e.target.closest && e.target.closest('[data-up-add]'); if (!b) return;
    e.preventDefault();
    var sel = b.closest('.cl-up__item').querySelector('.cl-up__var');
    b.disabled = true; b.textContent = '…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(sel.value), quantity: 1 }) })
      .then(function(r){ return r.json(); })
      .then(function(j){ if (j.status) { b.textContent = 'Sold out'; return; }
        document.dispatchEvent(new CustomEvent('cart:build'));
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ zet(c); document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: j } })); }); })
      .catch(function(){ b.disabled = false; b.textContent = 'Add'; });
  });
})();
